import * as Sentry from "@sentry/react";
import { lazy } from "react";

import { sleep } from "../components/utils/util";

const NUM_RETRIES = 3;
const INTERVAL = 2000;
const LOCAL_STORAGE_KEY = "pageWasForceRefreshed";

const logWithSentry = (message: string) => {
  console.log(message);
  Sentry.captureMessage(message);
};

export const lazyWithRetry = <T extends React.ComponentType<any>>(componentImport: () => Promise<{ default: T }>) =>
  lazy(async () => {
    let retryCount = 0;

    const pageWasForceRefreshed = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "false");

    for (;;) {
      try {
        const component = await componentImport();

        if (pageWasForceRefreshed) {
          logWithSentry("WARN: Page fully reloaded due to chunk load failure");
        } else if (retryCount) {
          logWithSentry(`WARN: Lazy chunk load succeeded after ${retryCount} attempt${retryCount === 1 ? "" : "s"}`);
        }
        localStorage.removeItem(LOCAL_STORAGE_KEY);

        return component;
      } catch (err) {
        console.log("Error loading chunk: ", JSON.stringify(err, Object.getOwnPropertyNames(err)));
        retryCount += 1;
        if (retryCount < NUM_RETRIES) {
          await sleep(INTERVAL);
        } else if (!pageWasForceRefreshed) {
          localStorage.setItem(LOCAL_STORAGE_KEY, "true");
          Sentry.captureMessage("Forcing page reload due to chunk failure");
          window.location.reload();
        } else {
          throw err;
        }
      }
    }
  });
